import React from 'react';
import { VetChatCheckoutMessageContainer } from './components/VetChatCheckoutMessageContainer';
import { VetChatMessage } from './components/VetChatMessage';
import { VetChatMessageContainer } from './components/VetChatMessageContainer';
import { BotStages, UserStages } from './constants';
import { vetChatPetBirthdateAddedSegment, vetChatPetNameAddedSegment, vetChatPetWeightAddedSegment, vetChatPetBreedAddedSegment } from '../../data/segment/vet-chat-segment';
import { useSegmentTrack } from '..';
export const useVetChatbot = () => {
  const {
    executeTrack: executeSegmentTrack
  } = useSegmentTrack();
  const replyNameTrigger = ({
    name
  }) => {
    executeSegmentTrack({
      data: vetChatPetNameAddedSegment({
        name
      })
    });
    return BotStages.PetBreed;
  };
  const replyBreedTrigger = ({
    breed
  }) => {
    executeSegmentTrack({
      data: vetChatPetBreedAddedSegment({
        breed
      })
    });
    return BotStages.PetBirthday;
  };
  const replyBirthdayTrigger = ({
    birthday
  }) => {
    executeSegmentTrack({
      data: vetChatPetBirthdateAddedSegment({
        birthday
      })
    });
    return BotStages.PetWeight;
  };
  const replyWeightTrigger = ({
    weight
  }) => {
    executeSegmentTrack({
      data: vetChatPetWeightAddedSegment({
        weight
      })
    });
    return BotStages.Checkout;
  };
  const chatbotSteps = [{
    id: BotStages.PetName,
    component: <VetChatMessage botName="Anna, Veterinarian's Assistant">
          {'Welcome to Wag! Vet Chat. I\'ll get you connected with a veterinarian professional shortly, but first let me gather some basic info on your pet. Can you tell me your pet\'s name?'}
        </VetChatMessage>,
    asMessage: true,
    trigger: UserStages.ReplyPetName
  }, {
    id: UserStages.ReplyPetName,
    user: true,
    trigger: ({
      value
    }) => replyNameTrigger({
      name: value
    })
  }, {
    id: BotStages.PetBreed,
    component: <VetChatMessageContainer>
          {({
        steps,
        getPossessivePetName
      }) => {
        const formattedName = getPossessivePetName(steps[UserStages.ReplyPetName].value);
        return <VetChatMessage>
                {`Great, and what is ${formattedName} breed? If you're not sure, you can simply say "mixed breed"`}
              </VetChatMessage>;
      }}
        </VetChatMessageContainer>,
    asMessage: true,
    trigger: UserStages.ReplyPetBreed
  }, {
    id: UserStages.ReplyPetBreed,
    user: true,
    trigger: ({
      value
    }) => replyBreedTrigger({
      breed: value
    })
  }, {
    id: BotStages.PetBirthday,
    component: <VetChatMessageContainer>
          {({
        steps,
        formatPetName,
        getPossessivePetName
      }) => {
        const name = steps[UserStages.ReplyPetName].value;
        const formattedName = formatPetName(name);
        const possessiveName = getPossessivePetName(name);
        return <VetChatMessage>
                {`Just a couple more questions about ${formattedName} and you'll be ready to chat with an expert. Knowing a pet's age helps us better diagnose potential health issues. Do you know ${possessiveName} birth date? If not, can you give me your best guess at the year? (ex: mm/dd/yyyy)`}
              </VetChatMessage>;
      }}
        </VetChatMessageContainer>,
    asMessage: true,
    trigger: UserStages.ReplyPetBirthday
  }, {
    id: UserStages.ReplyPetBirthday,
    user: true,
    trigger: ({
      value
    }) => replyBirthdayTrigger({
      birthday: value
    })
  }, {
    id: BotStages.PetWeight,
    component: <VetChatMessageContainer>
          {({
        steps,
        formatPetName
      }) => {
        const name = steps[UserStages.ReplyPetName].value;
        const formattedName = formatPetName(name);
        return <VetChatMessage>
                {`One last thing that is helpful for our consults. About how many pounds is ${formattedName}?`}
              </VetChatMessage>;
      }}
        </VetChatMessageContainer>,
    asMessage: true,
    trigger: UserStages.ReplyPetWeight
  }, {
    id: UserStages.ReplyPetWeight,
    options: [{
      label: 'S: 5 - 20 lb',
      value: 5,
      trigger: ({
        value
      }) => replyWeightTrigger({
        weight: value
      })
    }, {
      label: 'M: 21 - 50 lb',
      value: 21,
      trigger: ({
        value
      }) => replyWeightTrigger({
        weight: value
      })
    }, {
      label: 'L: 51 - 99 lb',
      value: 51,
      trigger: ({
        value
      }) => replyWeightTrigger({
        weight: value
      })
    }, {
      label: 'XL: 100+ lb',
      value: 100,
      trigger: ({
        value
      }) => replyWeightTrigger({
        weight: value
      })
    }]
  }, {
    id: BotStages.Checkout,
    component: <VetChatMessageContainer>
          {({
        steps,
        formatPetName,
        formatPetBreed,
        tryValidatingOrReturnFallbackBirthday
      }) => <VetChatCheckoutMessageContainer steps={steps} formatPetName={formatPetName} formatPetBreed={formatPetBreed} tryValidatingOrReturnFallbackBirthday={tryValidatingOrReturnFallbackBirthday} />}
        </VetChatMessageContainer>,
    asMessage: true,
    end: true
  }];
  return {
    steps: chatbotSteps
  };
};